import { ref as A, watch as b } from "vue";
import { makeList as g } from "./index578.js";
const v = (t) => {
  const e = (s, l) => s || l, r = (s) => s !== !0;
  return t.map(e).filter(r);
}, f = (t, e, r) => ({
  getHoursList: (u, i) => g(24, t && (() => t?.(u, i))),
  getMinutesList: (u, i, a) => g(
    60,
    e && (() => e?.(u, i, a))
  ),
  getSecondsList: (u, i, a, n) => g(
    60,
    r && (() => r?.(u, i, a, n))
  )
}), H = (t, e, r) => {
  const { getHoursList: s, getMinutesList: l, getSecondsList: m } = f(
    t,
    e,
    r
  );
  return {
    getAvailableHours: (n, o) => v(s(n, o)),
    getAvailableMinutes: (n, o, c) => v(l(n, o, c)),
    getAvailableSeconds: (n, o, c, L) => v(m(n, o, c, L))
  };
}, M = (t) => {
  const e = A(t.parsedValue);
  return b(
    () => t.visible,
    (r) => {
      r || (e.value = t.parsedValue);
    }
  ), e;
};
export {
  H as buildAvailableTimeSlotGetter,
  f as getTimeLists,
  M as useOldValue
};
